<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <router-link
          to="/principal/enterprises/add"
          class="btn btn-secondary"
          v-if="$can('create', 'Tiendas')"
        >Agregar Tienda</router-link>
      </div>
    </div>
    <vue-good-table
      mode="remote"
      :columns="columns"
      :rows="rows"
      :totalRows="totalRecords"
      :sort-options="{
          enabled: true,
          initialSortBy: [{field: 'name', type: 'asc'}]
        }"
      :isLoading.sync="isLoading"
      styleClass="vgt-table bordered"
      :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'config' && $can('config', 'Tiendas')">
          <router-link
            :to="{ name: 'enterprisesParams', params: { enterprise_id: props.row.id, enterprise_name: props.row.name }}"
            class="btn btn-secondary"
          >Configurar</router-link>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Nombre de Empresa',
          field: 'name',
          filterOptions: {
            placeholder: 'Nombre de Empresa',
            enabled: true
          }
        },
        {
          label: 'Dirección',
          field: 'address',
          filterOptions: {
            placeholder: 'Dirección',
            enabled: true
          }
        },
        {
          label: 'Estado',
          field: 'state',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true
          }
        },
        {
          label: 'Ciudad',
          field: 'city',
          filterOptions: {
            placeholder: 'Ciudad',
            enabled: true
          }
        },
        {
          label: 'Contacto Tél.',
          field: 'phone',
          filterOptions: {
            placeholder: 'Contacto Tél.',
            enabled: true
          }
        },
        {
          label: 'Empleados activos',
          field: 'empleados',
          type: 'number',
          filterOptions: {
            placeholder: 'Rfc',
            enabled: true
          }
        },
        {
          label: 'Configurar Parametros',
          field: 'config'
        }
      ]
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getEnterprises')
        console.log(response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            this.rows = response.data.rows
          } else {
            this.rows = []
          }
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
